import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Landing = lazy(() => import('./Landing'));

const LandingRoute: FuseRouteItemType = {
	path: '/landing',
	element: <Landing />
};

export default LandingRoute;
